/** Zone-tuple identity helpers. A zone IS its (Takt_A, Takt_B, Takt_C) — every
 *  surface (grid rows, staging handlers, draftOps) keys on these so they bucket
 *  zones identically. */
import type { ZoneTuple } from "../../../models";
import type { ZoneRow } from "./types";

/** Stable key for a (Takt_A/B/C) tuple. */
export function zoneKey(takt_a: string, takt_b: string, takt_c: string): string {
  return `${takt_a}||${takt_b}||${takt_c}`;
}

/** Normalize anything carrying Takt_A/B/C (a row, taktification, new-activity,
 *  or zone tuple) into a bare ZoneTuple with null/undefined coerced to "". */
export function zoneOf(x: {
  takt_a?: string | null;
  takt_b?: string | null;
  takt_c?: string | null;
}): ZoneTuple {
  return { takt_a: x.takt_a || "", takt_b: x.takt_b || "", takt_c: x.takt_c || "" };
}

/** True when two normalized zone tuples are the same zone. */
export function sameZone(a: ZoneTuple, b: ZoneTuple): boolean {
  return a.takt_a === b.takt_a && a.takt_b === b.takt_b && a.takt_c === b.takt_c;
}

/** zoneKey for a grid row. */
export function zoneRowKey(r: ZoneRow): string {
  return zoneKey(r.takt_a, r.takt_b, r.takt_c);
}
